jQuery(document).ready(function($) {
  $('#ajax-registration-form').submit(function(event) {
    event.preventDefault();
    var checkAcceptTimeout; // Збереження ідентифікатора таймера
    var usernameInput = $('#username');
    var emailInput = $('#email');
    var passwordInput = $('#password');
    var acceptCheckbox = $('.accept input[type="checkbox"]');
	var acceptElement = $('.accept');
    var usernameRegex = /^[A-Za-z0-9]+$/;
    var isFormValid = true;


    // Перевіряємо заповненість полів
    if (!usernameInput.val() || !emailInput.val() || !passwordInput.val()) {
      var errorMessage = '';

      if (!usernameInput.val() && !emailInput.val() && !passwordInput.val()) {
        errorMessage = localized_texts.enter_fields;
        displayNotification(errorMessage, false, 3);
        removeErrorClass();
        usernameInput.addClass('error');
        emailInput.addClass('error');
        passwordInput.addClass('error');
        isFormValid = false
      } else if (!usernameInput.val() && !emailInput.val()) {
        errorMessage = localized_texts.enter_fields_user_email;
        displayNotification(errorMessage, false, 3);
        removeErrorClass();
        usernameInput.addClass('error');
        emailInput.addClass('error');
        isFormValid = false
      } else if (!usernameInput.val() && !passwordInput.val()) {
        errorMessage = localized_texts.enter_fields_user_pass;
        displayNotification(errorMessage, false, 3);
        removeErrorClass();
        usernameInput.addClass('error');
        passwordInput.addClass('error');
        isFormValid = false
      } else if (!emailInput.val() && !passwordInput.val()) {
        errorMessage = localized_texts.enter_fields_email_pass;
        displayNotification(errorMessage, false, 3);
        removeErrorClass();
        emailInput.addClass('error');
        passwordInput.addClass('error');
        isFormValid = false
      } else if (!usernameInput.val()) {
        errorMessage = localized_texts.enter_username;
        displayNotification(errorMessage, false, 3);
        removeErrorClass();
        usernameInput.addClass('error');
        isFormValid = false
      } else if (!emailInput.val()) {
        errorMessage = localized_texts.enter_email;
        displayNotification(errorMessage, false, 3);
        removeErrorClass();
        emailInput.addClass('error');
        isFormValid = false
      } else if (!passwordInput.val()) {
        errorMessage = localized_texts.enter_password;
        displayNotification(errorMessage, false, 3);
        removeErrorClass();
        passwordInput.addClass('error');
        isFormValid = false
      }
    }

    if (usernameInput.val() && !usernameRegex.test(usernameInput.val())) {
      errorMessage = localized_texts.enter_rules;
      displayNotification(errorMessage, false, 3);
      removeErrorClass();
      usernameInput.addClass('error');
      isFormValid = false;
    }

    if(!acceptCheckbox.prop('checked')) {
      checkAccept();
      isFormValid = false;
    }

    if (isFormValid) {
      var formData = $(this).serialize();
      $.ajax({
        type: 'POST',
        url: ajax_registration.ajax_url,
        data: formData + '&action=ajax_registration_callback',
        success: function (response) {
          var jsonResponse = JSON.parse(response);
          if (jsonResponse.success){
            removeErrorClass();
            displayNotification(jsonResponse.message, jsonResponse.success, 3);
            setTimeout(function() { // Додаємо затримку перед оновленням HTML
              location.reload();
            }, 3100); // Затримка 3.1 секунди
          } else{
            displayNotification(jsonResponse.message, jsonResponse.success, 3);
            if (jsonResponse.field) {
              removeErrorClass();
              $('#' + jsonResponse.field).addClass('error');
            }
          }
        }
      });
    }
  });

  // Функція для відображення повідомлень
  function displayNotification(message, isSuccess, durationInSeconds = 15) {
    var notificationElement = $('.modal_notification');
    notificationElement.text(message).addClass('visible');
    if (!isSuccess) {
      notificationElement.addClass('error');
    } else {
      notificationElement.removeClass('error').addClass('success');
    }
    setTimeout(function() {
      notificationElement.removeClass('visible error success');
    }, durationInSeconds * 1000); // 15 секунд
  }

  // Кнопка для відкриття модального вікна реєстрації
  $('#registr').click(function() {
    $('#modal-reg').addClass('open');
  });

  function checkAccept() {
    var notificationElement = $('.modal_notification');
    var acceptElement = $('.accept');

    if (!notificationElement.hasClass('visible')) {
      displayNotification(localized_texts.privacy, false, 3);
      removeErrorClass();
      acceptElement.addClass('error');
    } else {
      setTimeout(checkAccept, 1200);
    }
  }

  function removeErrorClass() {
        var errorElement = document.querySelectorAll('.modal_form .error'); // Отримуємо всі елементи введення з класом помилки
          errorElement.forEach(function(input) { // Ітеруємося по кожному елементу
            input.classList.remove('error'); // Видаляємо клас помилки
        });
    }

});
